import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const deleteFeedbackFunc = createAsyncThunk("feedback/delete", async (feedbackId) => {
  const tokenData = await JSON.parse(localStorage.getItem("userData")).token;
  const request = await fetch(
    `${process.env.REACT_APP_VERSEL_API}/api/users/feedbacks/${feedbackId}`,
    {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${tokenData}`,
      },
    }
  )
    .then((respons) => respons.json())
    .then((resulet) => {
      return resulet;
    })
    .catch((e) => {
      return e;
    });

  return request;
});


const deleteFeedbackSlicer = createSlice({
  name: "feedback/delete",
  initialState: {
    loading: null,
    responst: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(deleteFeedbackFunc.pending, (state, action) => {
    state.loading = true;
    });
    builder.addCase(deleteFeedbackFunc.fulfilled, (state, action) => {
      if (action.payload.message === "deleted successfully") {
        state.responst = action.payload.message;
      } else {
        state.error = action.payload.message;
      }
      state.loading = false;
    });
    builder.addCase(deleteFeedbackFunc.rejected, (state, action) => {
      state.error = action.payload.message;
      state.loading = false;
    });
  },
});

export default deleteFeedbackSlicer.reducer;
